module.exports = __webpack_public_path__ + "img/04.ffc4fe01.png";